<script setup lang="ts">
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { T } from '@tolgee/vue'
import BaseButton from '@/components/base/BaseButton.vue'
import NavbarMoneyImage from '@/components/navbar-icons/NavbarMoneyImage.vue'
import { useSpecialCollectibleChallenge } from '@/composables/game/challenges'

defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  hide: []
}>()

const { currencyImage } = useSpecialCollectibleChallenge()

function handleClose() {
  emit('hide')
}
</script>

<template>
  <TheBottomSheet
    :show="show"
    wrapper-class="z-[801]"
    :centered="true"
    @hide="handleClose"
  >
    <div class="w-full flex flex-col gap-y-3">
      <h2 class="text-solid-white text-lg font-bold mb-1">
        <T
          key-name="collectible_challenge.rules.title"
          default-value="How it works?"
        />
      </h2>

      <div class="flex gap-x-4">
        <div class="flex-shrink-0">
          <img
            v-if="currencyImage"
            :src="currencyImage"
            class="size-6"
            alt="Collectible"
          >
        </div>
        <div class="flex flex-col gap-y-1">
          <p class="text-base font-medium text-white/60 leading-tight">
            <span class="text-white/[0.87] font-medium">
              <T
                key-name="collectible_challenge.rules.solve_quickly.title"
                default-value="Collect"
              />
            </span>
            <T
              key-name="collectible_challenge.rules.solve_quickly.description"
              default-value=" as many of the selected item as you can."
            />
          </p>
        </div>
      </div>

      <div class="flex gap-x-4">
        <div class="flex-shrink-0">
          <NavbarMoneyImage class="size-6" />
        </div>
        <div class="flex flex-col gap-y-1">
          <p class="text-base font-medium text-white/60 leading-tight">
            <span class="text-white/[0.87] font-medium">
              <T
                key-name="collectible_challenge.rules.wallet.title"
                default-value="Only"
              />
            </span>
            <T
              key-name="collectible_challenge.rules.wallet.description"
              default-value=" connected wallets will receive rewards."
            />
          </p>
        </div>
      </div>

      <BaseButton
        class="w-full mt-3"
        style-type="secondary"
        button-class="h-14 text-lg font-bold uppercase tracking-wider"
        @click="handleClose"
      >
        <T
          key-name="collectible_challenge.rules.got_it"
          default-value="GOT IT"
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>

<style scoped lang="scss">
</style>